import { useEffect, useState } from "react";
import useDataBean from "../../../../../../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../../../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../../../../../../theme/Component/ListMenu";
import { BasicPage } from "../../../../../../../theme/Component/BasicPage";
import { BasicTable } from "../../../../../../../theme/Component/BasicTable";
import { _FinancialTaxPaymentOrder, _TaxMovement } from "../../../../../../../../core/services/dataBean/EntityCatalogVdos";
import { InputDate } from "../../../../../../../theme/Input/InputDate";
import { FinancialMovementTax } from "../../../../../../../RemoteAbstractAction/components/com/quickdataerp/bean/tax/FinancialMovementTax/FinancialMovementTax";
import { AccountEditor } from "../../../../../../../editor/AccountEditor";
import { CostingCenterSelect } from "../../../../../../../erp/cellEditor/CostingCenter/CostingCenterSelect";
import { EditorCostingCenter } from "../../../../../../../erp/cellEditor/CostingCenter/EditorCostingCenter";
import { ProjectSelectVdos } from "../../../../../../../RemoteAbstractAction/editors/ProjectSelectVdos";
import { SelectBusinessCore } from "../../../../../../../erp/cellEditor/BusinessCore/SelectBusinessCore";
import { OBsEditor } from "../../OBsEditor";
import { OBsBudgetEditor } from "../Component/OBsBudgetEditor";
import { _single } from "../../../../../../../../core/services/dataBean/EntityCatalog";
import { BasicButton } from "../../../../../../../theme/Component/BasicButton";
import { Modal } from "../../../../../../../theme/Component/Modal";
import { DocumentViewer } from "../../../../../../../theme/Component/DocumentViewer";
import { InputMoney } from "../../../../../../../theme/Input/InputMoney";
import { PrintJson } from "../../../../../../../theme/Component/PrintJson";



export const FinancialTaxPaymentOrder = () => {

    const FinancialTaxPaymentOrder = useDataBean(_FinancialTaxPaymentOrder);
    const TaxMovement = useDataBean(_TaxMovement);
    const single = Singleton.getInstance();
    const [aBean, setABean] = useState<any>({})
    const [lista, setLista] = useState<any>([]);
    const [docs, setDocs] = useState<any>([]);
    const [registros, setRegistros] = useState<any[]>([]);
    const [modaldoc, setModaldoc] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalagregarlista, setModalagregarlista] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [visualizar, setvisualizar] = useState<any>(null)
    const [visualizarcrear, setvisualizarcrear] = useState<any>(null)
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });




    const createFinancialTaxPaymentOrder = () => {

        FinancialTaxPaymentOrder.instance.createFinancialTaxPaymentOrder(FinancialTaxPaymentOrder.bean.AccountantDate, aBean.IDTaxSchemeValue, FinancialTaxPaymentOrder.bean.IDAccount, FinancialTaxPaymentOrder.bean.Description, lista, FinancialTaxPaymentOrder.bean.BudgetID, FinancialTaxPaymentOrder.bean.OBIDDocument, FinancialTaxPaymentOrder.bean.OBDate, FinancialTaxPaymentOrder.bean.IDBudgetType, FinancialTaxPaymentOrder.bean.IDBudgetResource, FinancialTaxPaymentOrder.bean.IDBudgetSource, _single.getAccountID()).then(
            (resp: any) => {
                if (resp) {
                    toast.success('Creado');
                    setModaldoc({ ...modaldoc, "view": true });
                    setDocs(resp.DocumentURL);
                }
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const createPaymentOrderTaxMovement = () => {

        TaxMovement.instance.createPaymentOrderTaxMovement(TaxMovement.bean.CostingCenterCode, TaxMovement.bean.IDBusinessCore, TaxMovement.bean.IDProject, TaxMovement.bean.Value).then(
            (resp: any) => {
                if (resp) {
                    console.log(resp)
                    toast.success('Lista Creada');
                    const data = resp;
                    setvisualizar(true)
                    setvisualizarcrear(true)
                    if (data) {
                        const nuevaLista = [...lista, data];
                        setLista(nuevaLista);
                        setRegistros(nuevaLista);
                        toast.success("Registro agregado a la tabla");
                        setModalagregarlista({ ...modalagregarlista, "view": false });
                    }
                    setModalagregarlista({ ...modalagregarlista, "view": false });
                    // setDocs(resp.DocumentURL);
                }
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const AgregarLista = () => {
        // Reiniciar el bean de TaxMovement con campos vacíos
        TaxMovement.setBean({
            Value: null,
            CostingCenterCode: "",
            IDProject: null,
            IDBusinessCore: null,
            BusinessCoreCodeName: "",
            CostingCenterCodeName: "",
        });

        // Mostrar el modal
        setModalagregarlista({ ...modalagregarlista, view: true });
    };

    const create = () => {
        FinancialTaxPaymentOrder.setBean({

        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        FinancialTaxPaymentOrder.deleteItemVoid(FinancialTaxPaymentOrder.bean).then(
            (resp: any) => {

                setModalC({ ...modalC, "view": false });
            }
        )

    }
    const head = [
        { title: 'Nombre Proyecto', property: "ProjectName" },
        { title: 'Centro de Costo', property: "CostingCenterName" },
        { title: 'Unidad de Negocio', property: "BusinessCoreName" },

    ]
    const editaItem = () => {
        //console.log(entailment.bean);
        FinancialTaxPaymentOrder.update().then(
            (resp: any) => {

                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }




    return (
        <BasicPage titulo="Ordenes de Pago para Gravamenes Financieros">
            <div className="row">
                <div className="col-md-12">
                    <InputDate name="AccountantDate" label="Fecha de Registro" value={FinancialTaxPaymentOrder.bean.AccountantDate} setDate={(e: any) => { FinancialTaxPaymentOrder.setBean({ ...FinancialTaxPaymentOrder.bean, "AccountantDate": e }) }} />
                </div>
                <div className="col-md-6">
                    <FinancialMovementTax onChange={(e) => { setABean({ ...aBean, IDTaxSchemeValue: Number(e) }) }} label="Gravámen Movimiento Financiero (GMF)" />
                </div>
                <div className="col-md-6">
                    <AccountEditor label="Tercero" idAccount={FinancialTaxPaymentOrder.bean.IDAccount} onChange={(e) => { FinancialTaxPaymentOrder.setBean({ ...FinancialTaxPaymentOrder.bean, "IDAccount": e.IDAccount }) }}></AccountEditor>
                </div>
                <div className="col-md-6">
                    <label>Obligación Presupuestal</label>
                    <OBsEditor idDocument={FinancialTaxPaymentOrder.bean.OBIDDocument} configProps={{ label: " " }} idAccount={FinancialTaxPaymentOrder.bean.IDAccount} paymentDate={FinancialTaxPaymentOrder.bean.AccountantDate}
                        onChange={(e) => {
                            console.log(e)
                            FinancialTaxPaymentOrder.setBean({
                                ...FinancialTaxPaymentOrder.bean,
                                "OBIDDocument": e.IDDocument,
                                "OBMnemonic": e.Mnemonic,
                                "OBConsecutive": e.Consecutive,
                                "OBDate": e.DocumentDate,
                                "OBDocumentState": e.DocumentSate,
                            })
                        }} />
                </div>

                <div className="col-md-6">
                    <label>Rubro Presupuestal</label>
                    <OBsBudgetEditor renderValue={FinancialTaxPaymentOrder.bean.BudgetName} _paymentDate={FinancialTaxPaymentOrder.bean.OBDate} configProps={{ label: " " }} idDocument={FinancialTaxPaymentOrder.bean.OBIDDocument}
                        onChange={(e) => { FinancialTaxPaymentOrder.setBean({ ...FinancialTaxPaymentOrder.bean, "BudgetID": e.BudgetIDStr, "IDBudgetResource": e.IDBudgetResource, "IDBudgetSource": e.IDBudgetSource, "IDBudgetType": e.IDBudgetType }) }} />
                </div>
                <div className="col-md-12">
                    <label>Descripción</label>
                    <textarea name="Description" className="form-control" value={FinancialTaxPaymentOrder.bean.Description} onChange={FinancialTaxPaymentOrder.handleChange} />
                </div>
                <div className="col-md-12">
                    <div className="row">
                        <div className="col-md-3 mt-4 p-2">
                            <BasicButton icon="ri-add-circle-line" clase="secondary" eventClick={AgregarLista}>Agregar Lista de movimientos</BasicButton>
                        </div>

                    </div>
                </div>
                {visualizar && <>

                    <div className="col-md-12 mt-5">
                        <BasicPage titulo='Lista de movimientos'>
                            <>
                                <div className="col-md-12 mt-4">
                                    <h5>Registros Guardados</h5>
                                    <table className="table table-bordered table-striped">
                                        <thead>
                                            <tr>
                                                <th>Unidad de Negocio</th>

                                                <th>Valor</th>
                                                <th>Centro de Costo</th>
                                                <th>Proyecto</th>

                                            </tr>
                                        </thead>
                                        <tbody>
                                            {(Array.isArray(registros) ? registros : []).map((item, index) => (
                                                <tr key={index}>
                                                    <td>{item.BusinessCoreName ?? ''}</td>
                                                    <td>{item.Value ?? ''}</td>
                                                    <td>{item.CostingCenterName ?? ''}</td>
                                                    <td>{item.ProjectName ?? ''}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                                {/* <PrintJson json={TaxMovement.bean} />
                                <PrintJson json={lista} /> */}
                            </>
                        </BasicPage>

                    </div>
                </>}
                {visualizarcrear && <>
                    <div className="col-md-2 mt-4 p-2">
                        <BasicButton icon="ri-send-plane-fill" clase="primary" eventClick={createFinancialTaxPaymentOrder}>Crear</BasicButton>
                    </div>
                </>}
                <div className="col-md-12">
                    <Modal modal={modalagregarlista} updateModal={setModalagregarlista} eventModal={createPaymentOrderTaxMovement}>
                        <div className="row">
                            <div className="col-md-6">

                                <InputMoney _label="Valor a Girar" _value={TaxMovement.bean.Value} onChange={(e) => { TaxMovement.setBean({ ...FinancialTaxPaymentOrder.bean, "Value": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <EditorCostingCenter render={TaxMovement.bean.CostingCenterCode} idSelector={TaxMovement.bean.CostingCenterCode} onChange={(e) => { TaxMovement.setBean({ ...TaxMovement.bean, "CostingCenterCode": e.Code, "CostingCenterCodeName": e.Code, "IDBusinessCore": e.IDBusinessCore }) }} label="Centro de Costo" returnType="Object" />
                            </div>
                            <div className="col-md-6">
                                <ProjectSelectVdos label='Proyecto' idSelector={TaxMovement.bean.IDProject} onChange={(e) => { TaxMovement.setBean({ ...TaxMovement.bean, "IDProject": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <SelectBusinessCore label='Unidad de Negocio' returnType="Object" idSelector={TaxMovement.bean.IDBusinessCore} onChange={(e) => { TaxMovement.setBean({ ...TaxMovement.bean, "IDBusinessCore": e.IDBusinessCore, "BusinessCoreCodeName": `${e.Code} - ${e.Name}` }) }} />
                            </div>
                        </div>
                    </Modal>
                </div>
                <div className="col-md-12">
                    <Modal modal={modaldoc} updateModal={setModaldoc}>
                        <div className="row">
                            <div className="col-md-12">
                                <DocumentViewer
                                    list={docs}
                                />
                            </div>
                        </div>
                    </Modal>
                </div>
            </div>
        </BasicPage>
    )
}